import React from 'react';

import PolicyPage from '../common/PolicyPage';

const AcceptableUsePolicy: React.FC = () => {
  return <PolicyPage name="acceptable-use-policy" title="Acceptable Use Policy" />;
};

export default AcceptableUsePolicy;
